import hack from "./hack";
// import http from "./config";

const isRmt = hack.isRmt;

const share = shareData => {
  hack.share(shareData);
};

const open = options => {
  hack.open(options);
  console.log(options, "...options");
};

const getContents = options => {
  console.log("...", options);
};

const getContent = options => {
  console.log("...", options);
};

export { isRmt, share, open, getContents, getContent };
